import { Check } from 'lucide-react';
import { ColorSelectorProps, ColorOption } from '../../types/calendar';

const colorOptions: ColorOption[] = [
  { id: 'black', name: 'Black', value: '#000000' },
  { id: 'white', name: 'White', value: '#FFFFFF' },
  { id: 'gray', name: 'Gray', value: '#6B7280' },
  { id: 'red', name: 'Red', value: '#DC2626' },
  { id: 'blue', name: 'Blue', value: '#2563EB' },
  { id: 'green', name: 'Green', value: '#16A34A' },
  { id: 'yellow', name: 'Yellow', value: '#EAB308' },
  { id: 'purple', name: 'Purple', value: '#9333EA' },
  { id: 'pink', name: 'Pink', value: '#EC4899' },
  { id: 'orange', name: 'Orange', value: '#EA580C' },
  { id: 'teal', name: 'Teal', value: '#14B8A6' },
  { id: 'navy', name: 'Navy', value: '#1E3A8A' }
];

export function ColorSelector({ selectedColor, onColorSelect }: ColorSelectorProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">Text Color</label>
      <div className="grid grid-cols-6 gap-2">
        {colorOptions.map((color) => (
          <button
            key={color.id}
            type="button"
            onClick={() => onColorSelect(color.value)}
            className="relative w-10 h-10 rounded-md border-2 transition-all hover:scale-110 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            style={{
              backgroundColor: color.value,
              borderColor: color.value === selectedColor ? '#2563EB' : '#D1D5DB'
            }}
            title={color.name}
            aria-label={color.name}
          >
            {color.value === selectedColor && (
              <Check
                className="absolute inset-0 m-auto w-5 h-5"
                style={{ color: color.value === '#FFFFFF' ? '#000000' : '#FFFFFF' }}
              />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
